/* ============================================================================
   Product-card native image swiper
   Loaded once per page (see theme.liquid). Previously rendered inline per card,
   which polluted carousels with <style>/<script> cells and broke arrow nav.
   ========================================================================== */
(function () {
  'use strict';

  function initSwiper(el) {
    const track   = el.querySelector('[data-pc-track]');
    const btnPrev = el.querySelector('[data-pc-prev]');
    const btnNext = el.querySelector('[data-pc-next]');
    const dots    = el.querySelectorAll('[data-pc-dot]');
    const count   = el.querySelectorAll('.pc-swiper__slide').length;

    if (!track || count < 2) return;

    let current   = 0;
    let startX    = 0;
    let startY    = 0;
    let diffX     = 0;
    let dragging  = false;
    let isScrolling = null;

    /* ── Go to slide ── */
    function goTo(index) {
      current = Math.max(0, Math.min(index, count - 1));
      track.style.transition = 'transform 0.38s cubic-bezier(0.25,0.46,0.45,0.94)';
      track.style.transform  = 'translateX(-' + (current * 100) + '%)';

      /* dots */
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.pcDot) === current);
      });

      /* arrow visibility */
      if (btnPrev) btnPrev.toggleAttribute('data-hidden', current === 0);
      if (btnNext) btnNext.toggleAttribute('data-hidden', current === count - 1);

      /* tabindex on links */
      el.querySelectorAll('.pc-swiper__slide').forEach(function (slide, i) {
        const link = slide.querySelector('a');
        if (link) link.tabIndex = i === current ? 0 : -1;
      });
    }

    /* ── Buttons ── */
    if (btnPrev) {
      btnPrev.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(current - 1);
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(current + 1);
      });
    }

    /* ── Touch ── */
    el.addEventListener('touchstart', function (e) {
      startX     = e.touches[0].clientX;
      startY     = e.touches[0].clientY;
      diffX      = 0;
      dragging   = false;
      isScrolling = null;
      track.style.transition = 'none';
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!e.touches[0]) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (isScrolling === null) {
        isScrolling = Math.abs(dy) > Math.abs(dx);
      }

      if (isScrolling) return;

      dragging = true;
      diffX    = dx;
      e.preventDefault();
      track.style.transform = 'translateX(calc(-' + (current * 100) + '% + ' + diffX + 'px))';
    }, { passive: false });

    el.addEventListener('touchend', function () {
      if (!dragging) return;
      const threshold = el.offsetWidth * 0.2;
      if (diffX < -threshold)      goTo(current + 1);
      else if (diffX > threshold)  goTo(current - 1);
      else                          goTo(current);
    });

    /* ── Init state ── */
    goTo(0);
  }

  /* ── Observe & init ── */
  function setup() {
    document.querySelectorAll('[data-pc-swiper]:not([data-pc-ready])').forEach(function (el) {
      el.setAttribute('data-pc-ready', '');
      initSwiper(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* Theme editor & dynamic section reloads */
  document.addEventListener('shopify:section:load', function () { setTimeout(setup, 50); });

  /* Async-injected cards (e.g. <product-recommendations> "Complete the look",
     quick-buy modals) are added after load — observe and init them too. */
  if ('MutationObserver' in window) {
    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          if (!pending) {
            pending = true;
            (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; setup(); });
          }
          break;
        }
      }
    });
    var startObserving = function () { observer.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) { startObserving(); }
    else { document.addEventListener('DOMContentLoaded', startObserving); }
  }
})();
